import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Canal d'ouverture du slide-over "Mes listes de contrôle" (wilout/issues#4956).
 * Permet de déclencher l'ouverture depuis n'importe quel composant (header, dashboard…).
 * AppComponent souscrit à `open$` et affiche <app-mes-listes-controle>.
 */
@Injectable({ providedIn: 'root' })
export class MesListesUiService {
  private readonly _open = new Subject<void>();
  readonly open$ = this._open.asObservable();

  open(): void {
    this._open.next();
  }
}
